// ** React Imports
import { useEffect } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import { useState } from "react";

// ** Custom Components
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import Block from "components/layout/Block";

const rawItems = [
	{
		key: "visitorsall",
		value: "visitorsall",
	},
	{
		key: "VisitorsWhoIamSearch",
		value: "VisitorsWhoIamSearch",
	},
];

export const AllowedSexDropdown = ({ state, dispatch }) => {
	const { t } = useTranslation(["common", "userpanel"]);

	const [selected, setSelected] = useState(null);
	const items = rawItems.map((item) => ({
		...item,
		content: t(
			`userpanel:settings.preferences.allow.${item.key.toLowerCase()}`,
		),
	}));

	useEffect(() => {
		setSelected(
			!state.allowVisitorsWhoIamSearch
				? "visitorsall"
				: "VisitorsWhoIamSearch",
		);
	}, [state.allowVisitorsWhoIamSearch]);
	return (
		<Block mt={2} style={{ width: "300px" }}>
			<SelectorSelectSingle
				label={t("userpanel:settings:preferences:allow:visitors")}
				items={items}
				selected={selected}
				onAccept={(value) => {
					if (value === null) return;

					setSelected(value);
					dispatch({
						type: "SET",
						field: `allowVisitorsWhoIamSearch`,
					});
				}}
				withMobileVersion
				activatorStyleOptions={{
					noPad: true,
					noTopMargin: true,
					flex1: true,
					noFullWidth: true,
				}}
			/>
		</Block>
	);
};
